import Card from 'components/general/Card/Card';
import GeographySummary, {
  GeographySummaryPropDef,
} from 'components/general/GeographySummary/GeographySummary';
import React from 'react';

const GeographyGrid: React.SFC<PropDef> = ({ items }) => (
  <ul className="l-geography-grid">
    {items.map(item => (
      <li className="l-geography-grid__item" key={item.slug}>
        <Card>
          <Card.Section
            to={{
              type: 'COUNTRIES_GEOGRAPHY',
              payload: { geography: item.slug },
            }}
          >
            <GeographySummary {...item} />
          </Card.Section>
        </Card>
      </li>
    ))}
  </ul>
);

GeographyGrid.defaultProps = {
  items: [],
};

interface PropDef {
  items: GeographySummaryPropDef[];
}

export default GeographyGrid;

